import store from "@/base/store";

export default store;
